'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteHeader = twentyninetimes.siteHeader || function () {

    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById('js-site-header'),
        header_height = header.clientHeight;

    function init() {
        if ( header ) {
           toggleHeader(header);
        }

        var breaking_banner = document.getElementById('js-breaking-banner');
        if ( breaking_banner ) {
            breakingBanner(breaking_banner);
        }
    }

    function checkScroll() {
      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;

      // Check if block-theme-header--dark exists and get its height
      var darkHeader = document.querySelector('.block-theme-header--dark');
      var darkHeaderHeight = darkHeader ? darkHeader.clientHeight : 0;

      // Change header logo if scrolled more than darkHeaderHeight
      if (darkHeader && curScroll > darkHeaderHeight) {
        header.classList.add('logo-changed');
      } else {
          header.classList.remove('logo-changed');
      }

      ( curScroll > header_height ) 
        ? header.classList.add('scrolled')
        : header.classList.remove('scrolled');

      // Check if sticky-nav exists and if scrolled to it
      var stickyNav = document.querySelector('.sticky-nav');
      if (stickyNav) {
          var offset = header_height; // Adjust this value as needed
          var stickyNavOffset = stickyNav.offsetTop - offset;
          if (curScroll >= stickyNavOffset) {
              stickyNav.classList.add('scrolled');
          } else {
              stickyNav.classList.remove('scrolled');
          }
      }

      if (curScroll > prevScroll) { 
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    }

    function toggleHeader(direction, curScroll) {
        
      if (direction === 2 && curScroll > header_height) { 

        document.body.classList.add('hide');
        prevDirection = direction;
      }
      else if (direction === 1) {
        document.body.classList.remove('hide');
        prevDirection = direction;
      }
    };

    function breakingBanner(banner) {
        var button = banner.querySelector('.site-header__breaking-banner-close');

        button.addEventListener('click', (e) => {
            e.stopPropagation();

            setCookie('breaking_banner', 1, 0);

            document.body.classList.remove('has-breaking-banner');

            setTimeout(() => {
                banner.parentNode.removeChild(banner);
            }, 300);
        });
    }

    return {
        init : init,
        checkScroll : checkScroll
    };

}();

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expireDays="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}